import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: {},
    token: '',
    isLoggedIn: false,
  },
  getters: {
    USER: (state) => state.user,
    IS_LOGGED_IN: (state) => state.isLoggedIn,
    TOKEN: (state) => state.token,
  },
  mutations: {
    SET_USER(state, payload) {
      state.user = payload;
    },
    SET_LOGGED_IN(state, payload) {
      state.isLoggedIn = payload;
    },
    SET_TOKEN(state, payload) {
      state.token = payload;
    },
  },
  actions: {
    SET_USER({ commit }, payload) {
      commit('SET_USER', payload);
    },
    SET_LOGGED_IN({ commit }, payload) {
      commit('SET_LOGGED_IN', payload);
    },
    SET_TOKEN({ commit }, payload) {
      commit('SET_TOKEN', payload);
    },
  },
  modules: {},
});
